import { EnrollmentStatus } from '@/pipeline/stateMachine';

export interface Course {
  id?: number;
  name?: string;
  descomplicaProviderCode?: string;
  descomplicaCurriculumId?: string;
}

export interface Campus {
  id?: number;
  name?: string;
  city?: string;
  state?: string;
}

export interface EnrollmentState {
  enrollmentId?: number;
  areDocumentsSent?: boolean;
  enrollmentStatus?: EnrollmentStatus;
  partnerCode?: string;
  /**
   * O cupom veio do link pessoal (`/?cupom=`), não foi digitado pelo aluno.
   * Nesse caso o campo em Dados Pessoais fica travado: trocá-lo desfaz a bolsa
   * e não existe caminho de reaplicar cupom depois da matrícula criada no ERP.
   */
  isPartnerCodeLocked?: boolean;
  course?: Course;
  campus?: Campus;
  hasErrorVoucher?: boolean;
  isComplementaryModuleEnabled?: boolean;
  backofficeStudentAcademicRecord?: string;
}

const enrollment: EnrollmentState = {
  enrollmentId: undefined,
  areDocumentsSent: undefined,
  enrollmentStatus: undefined,
  partnerCode: undefined,
  isPartnerCodeLocked: false,
  course: undefined,
  campus: undefined,
  hasErrorVoucher: undefined,
  isComplementaryModuleEnabled: undefined,
  backofficeStudentAcademicRecord: undefined,
};

export default enrollment;
